// Root-redirect: the real experience lives at /key-secure.html.
// Do this BEFORE we even import React/render, so users never see a flicker
// of the CRA-clobbered HTML when they land on "/" or "/index.html".
(function redirectToLanding() {
  if (typeof window === "undefined") return;
  const p = window.location.pathname;
  // Anything that's effectively "/" or the bare index.html → send to landing
  if (p === "/" || p === "" || p === "/index.html") {
    window.location.replace("/key-secure.html" + window.location.search + window.location.hash);
  }
})();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
